export default {
    font: "Quicksand,sans-serif",
    size: 1,
    lineHeight: 1.5,
    marginBottom: 0.5,

    h1: {
        font: "LuloCleanOne, sans-serif",
        size: 2.5,
        lineHeight: 1.2,
        marginBottom: 0.5,
    },
    h2: {
        font: "LuloCleanOne, sans-serif",
        size: 2,
        lineHeight: 1.2,
        marginBottom: 0.5,
    },
    h3: {
        font: "LuloCleanOne, sans-serif",
        size: 1.75,
        lineHeight: 1.2,
        marginBottom: 0.5,
    },
    h4: {
        font: "LuloCleanOne, sans-serif",
        size: 1.5,
        lineHeight: 1.2,
        marginBottom: 0.5,
    },
    h5: {
        font: "LuloCleanOne, sans-serif",
        size: 1.25,
        lineHeight: 1.2,
        marginBottom: 0.5,
    },
    h6: {
        font: "LuloCleanOne, sans-serif",
        size: 1,
        lineHeight: 1.2,
        marginBottom: 0.5,
    },
};
